module.exports = __webpack_public_path__ + "class-f2e0a1b860c32dedad55182617f4e1d7.svg";